var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('header-box'),_c('div',{staticClass:"home__no-auth-tips"},[_vm._v("暂无权限使用功能模块，请联系管理员添加权限")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }